import React from 'react';

import styled from 'styled-components';

import connectAuth, { IAuthMapStateToProps, IConnectedProps } from '../hooks/connectAuth';

import { Types } from '../Store/ContainerReducer';
import { IAuthState } from '../Store/Reducers';

interface IAuthError {
    error: string
}

type TAuthError = IConnectedProps<IAuthError>;

interface ICloseIcon {
    onClick: () => void
}

const ErrorMessage = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    box-sizing: border-box;
    border-radius: 0.25rem;
    padding: 0.9375rem 0.625rem;
    background-color: ${({ theme }) => theme.colors.red500};

    & > span {
        flex: 1;
        line-height: 1.5;
        font-size: 0.875em;
        color: ${({ theme }) => theme.colors.white};
    }

    & > svg {
        cursor: pointer;
        height: 0.875em;
        margin-left: 0.625em;

        & > g {
            fill: ${({ theme }) => theme.colors.white};
        }
    }
`;

const CloseIcon: React.FC<ICloseIcon> = ({ onClick }) => (
    <svg onClick={onClick} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 14">
        <g fillRule="evenodd">
            <path d="M7.487 6.442L14-.071l1.116 1.116L9.162 7l5.954 5.955L14 14.07 6.929 7l.558-.558z" />
            <path d="M8.513 7.558L2 14.071.884 12.955 6.838 7 .884 1.045 2-.07 9.071 7l-.558.558z" />
        </g>
    </svg>
);

const AuthError: React.FC<TAuthError> = ({ error, dispatch }) => {
    const handleCloseError = () => dispatch({
        type: Types.HANDLE_ERROR,
        data: ''
    });

    if (!error) return null;

    return (
        <ErrorMessage>
            <span>{error}</span>

            <CloseIcon onClick={handleCloseError} />
        </ErrorMessage>
    );
};

const mapStateToProps: IAuthMapStateToProps<IAuthError> = (state, isComparison = false) => ((!isComparison)
    ? { error: (state as IAuthState).Container.errorMessage }
    : { error: state.error }
);

export default connectAuth(mapStateToProps)(AuthError);
